import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent  {
bookingservices:boolean;
payingservices:boolean;
bookinganswer:boolean;
payinganswer:boolean;
loader:boolean = false;
answer2:boolean;
answer3:boolean;
answer4:boolean;
answer5:boolean;
answer6:boolean;
answer7:boolean;
answer8:boolean;
paying2:boolean;
paying3:boolean;

  constructor( private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public translate: TranslateService,
    private launchNavigator: LaunchNavigator,
      private geoCoder:NativeGeocoder,
    public auth: AuthService,  public location: LocationService) { }

    return(){
      if(!this.auth.loged()){
        this.router.navigate(['/customerCare']);  
      }else{
        this.router.navigate(['/customerCare1']);  
      } 
    } 

}
